import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { historyPush } from 'store/actions/system';

export default () => {
  const { pathname } = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(historyPush(pathname));
  }, [pathname, dispatch]);

  return null;
};
